import { ClickAwayListener, Grid, Tooltip, Typography, useTheme } from "@mui/material";
import { PlayerCharacterDisplay } from "../../model/character";
import SimpleTable from "../../components/SimpleTable";
import { ReactNode, useState } from "react";
import HeadingBar, { HeadingBarItem } from "../../components/HeadingBar";
import { StatDisplay } from "../../components/StatDisplay";

import { ReactComponent as ArmourIcon } from "../../components/icons/raw/Icon_Armour.svg";
import { ReactComponent as Armour0Icon } from "../../components/icons/raw/Icon_0End_Armour.svg";
import { ReactComponent as EnduranceIcon } from "../../components/icons/raw/Icon_Endurance.svg";
import { ReactComponent as DefenseIcon } from "../../components/icons/raw/Icon_Defence.svg";

interface OutfitDisplayProps {
    characterDisplay: PlayerCharacterDisplay;
    setSelected: (value: number) => void;
}

const OutfitDisplay = (props: OutfitDisplayProps) => {
    const theme = useTheme();
    const { characterDisplay, setSelected } = props;

    return <>
        <HeadingBar extendBunts>
            <Grid container paddingX={1}>
                <Grid item xs={8}><HeadingBarItem>Name</HeadingBarItem></Grid>
                <Grid item xs={1}><HeadingBarItem tooltip="Defence"><DefenseIcon fill={theme.palette.primary.contrastText} height="1em" /></HeadingBarItem></Grid>
                <Grid item xs={1}><HeadingBarItem tooltip="Endurance"><EnduranceIcon fill={theme.palette.primary.contrastText} height="1em" /></HeadingBarItem></Grid>
                <Grid item xs={1}><HeadingBarItem tooltip="Armor"><ArmourIcon fill={theme.palette.primary.contrastText} height="1em" /></HeadingBarItem></Grid>
                <Grid item xs={1}><HeadingBarItem tooltip="Armor at zero Endurance"><Armour0Icon fill={theme.palette.primary.contrastText} height="1em" /></HeadingBarItem></Grid>
            </Grid>
        </HeadingBar>
        <SimpleTable entries={characterDisplay.outfits.map((w, index) => {
            return <Grid container onClick={() => setSelected(index)}>
                <Grid item xs={8}><Typography fontWeight={700} fontSize={15}>{w.name}</Typography></Grid>
                <Grid item xs={1}>{StatDisplay(w.defence)}</Grid>
                <Grid item xs={1}>{StatDisplay(w.endurance)}</Grid>
                <Grid item xs={1}>{StatDisplay(w.armor)}</Grid>
                <Grid item xs={1}>{StatDisplay(w.armorAtZero)}</Grid>
                <Grid item xs={12}><Typography variant="caption">{w.features.join(", ")}</Typography></Grid>
            </Grid>
        })} />
    </>
}

export default OutfitDisplay